import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import ServicesPage from "./pages/ServicesPage";
import Solutions from "./pages/Solutions";
import Founders from "./pages/Founders";
import Blogs from "./pages/Blogs";
import Jobs from "./pages/Jobs";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./components/ScrollToTop";
import Career from "./pages/Career";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/it-services" element={<ServicesPage />} />
        <Route path="/engineering-services" element={<Solutions />} />
        <Route path="/careers" element={<Career />} />
        {/* <Route path="/founders" element={<Founders />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/jobs" element={<Jobs />} />*/}
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
